import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
    selector: '[zeroMask]',
    providers: [NgModel]
})
export class ZeroMaskDirective {
    @Input('zeroMask') maskLength!: number;

    constructor(private el: ElementRef<HTMLInputElement>, private model: NgModel) { }

    ngOnInit() {
        const masked = this.applyMask(this.el.nativeElement.value || '');
        this.el.nativeElement.value = masked;
        this.model.viewToModelUpdate(masked);
    }

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = event.target as HTMLInputElement;

        // Pega a posição atual do cursor
        const cursorPos = input.selectionStart || 0;

        // Captura apenas os números
        const numeric = input.value.replace(/\D/g, '');

        // Garante o tamanho máximo
        const truncated = numeric.slice(-this.maskLength);

        // Calcula quantos zeros faltam à esquerda
        const zeros = this.maskLength - truncated.length;
        const maskedValue = '0'.repeat(zeros) + truncated;

        // Atualiza o valor visual e o modelo
        input.value = maskedValue;
        this.model.viewToModelUpdate(maskedValue);

        // Mantém o cursor no lugar certo
        setTimeout(() => {
            const newCursorPos = Math.min(cursorPos + 1, this.maskLength);
            input.setSelectionRange(newCursorPos, newCursorPos);
        });
    }

    private applyMask(value: string): string {
        const numeric = value.replace(/\D/g, '').slice(0, this.maskLength);
        const zeros = this.maskLength - numeric.length;
        return '0'.repeat(zeros) + numeric;
    }
}
